import { baseUrl } from "../api";

export const bucketMultipartUploadsUrl = `${baseUrl}bucket-multipart-uploads/`;
